import { InsightsNavbar } from "@/components/InsightsNavbar";
import { AnimatedSection } from "@/components/AnimatedSection";
import { ScrollProgressIndicator } from "@/components/ScrollProgressIndicator";
import { Footer } from "@/components/Footer";
import { InsightsLeadModal } from "@/components/InsightsLeadModal";
import { InsightsBreadcrumb } from "@/components/InsightsBreadcrumb";
import { ReplyDeliverabilityHeroSection } from "@/components/insights/reply-deliverability/ReplyDeliverabilityHeroSection";
import { ReplyDeliverabilityTakeaway } from "@/components/insights/reply-deliverability/ReplyDeliverabilityTakeaway";
import { ReplyDeliverabilityFounderQuote } from "@/components/insights/reply-deliverability/ReplyDeliverabilityFounderQuote";
import { ReplyDeliverabilityKeyFindings } from "@/components/insights/reply-deliverability/ReplyDeliverabilityKeyFindings";
import { ReplyDeliverabilityStrategies } from "@/components/insights/reply-deliverability/ReplyDeliverabilityStrategies";
import { InsightSEO } from "@/hooks/useInsightSEO";
import { RelatedTools } from "@/components/RelatedTools";
import { InsightEngagementTracker } from "@/components/InsightEngagementTracker";
import { InsightFAQSection } from "@/components/InsightFAQSection";
import { InsightBenchmarks } from "@/components/InsightBenchmarks";
import { TableOfContents } from "@/components/TableOfContents";

const ReplyBasedDeliverability = () => {
  return (
    <>
      <InsightSEO 
        slug="reply-based-deliverability" 
        additionalKeywords={["reply rate", "email replies", "open rate dead", "ISP signals", "engagement metrics", "inbox placement"]}
      />
      <InsightEngagementTracker slug="reply-based-deliverability" title="Reply-Based Deliverability" />
      <InsightsNavbar showBack />
      <ScrollProgressIndicator />
      <TableOfContents />
      <InsightsLeadModal />
      <main className="page-container pb-16 sm:pb-20">
        <InsightsBreadcrumb 
          category="Deliverability" 
          currentPage="Reply-Based Deliverability" 
        />
        <ReplyDeliverabilityHeroSection />
        
        <AnimatedSection delay={100} className="mt-10 sm:mt-12">
          <ReplyDeliverabilityTakeaway />
        </AnimatedSection>

        <AnimatedSection delay={50} className="mt-8 sm:mt-10">
          <ReplyDeliverabilityFounderQuote />
        </AnimatedSection>

        <div className="section-divider" />

        <AnimatedSection delay={0}>
          <ReplyDeliverabilityKeyFindings />
        </AnimatedSection>
        
        <AnimatedSection delay={0}>
          <ReplyDeliverabilityStrategies />
        </AnimatedSection>
        
        {/* Benchmark Tables */}
        <AnimatedSection delay={0}>
          <InsightBenchmarks insightSlug="reply-based-deliverability" />
        </AnimatedSection>
        
        {/* FAQ Section */}
        <AnimatedSection delay={0}>
          <InsightFAQSection insightSlug="reply-based-deliverability" />
        </AnimatedSection>
        
        {/* Related Tools Section */}
        <AnimatedSection delay={0}>
          <RelatedTools insightSlug="reply-based-deliverability" />
        </AnimatedSection>
      </main>
      <Footer />
    </>
  );
};

export default ReplyBasedDeliverability;